// NATIVE 

// INSTALLED 

// CUSTOM
import { AxiosAdapter } from "../commons/adapters";
import { QueryPagination } from "../commons/interfaces";
import { buildQuery } from "../commons/utils/helpers";

const http = new AxiosAdapter();

export const getApplicationDataDropDownService = async () => {
    try {
        return await http.get<any>(`/v1/app-releases/get-apps-to-dropdown`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getApplicationDataDropDownService ', error);
    }
}

export const getAppReleaseByIdService = async (id: string) => {
    try {
        return await http.get<any>(`/v1/app-releases/${id}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getAppReleaseByIdService ', error);
    }
}

export const getAllAppReleasesService = async (query?: QueryPagination) => {
    try {
        return await http.get<any>(`/v1/app-releases?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('getAllAppReleasesService ', error);
    }
}

export const postAppReleaseService = async (data: any) => {
    try {
        return await http.post<any>(`/v1/app-releases`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('postAppReleaseService ', error);
    }
}

export const putAppReleaseService = async (id: string, data: any) => {
    try {
        return await http.put<any>(`/v1/app-releases/${id}`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('putAppReleaseService ', error);
    }
}

export const deleteAppReleaseService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.delete<any>(`/v1/app-releases/${id}?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('deleteAppReleaseService ', error);
    }
}

export const restoreAppReleaseService = async (id: string, query?: QueryPagination) => {
    try {
        return await http.patchTable<any>(`/v1/app-releases/${id}/restore?${buildQuery(query)}`);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('restoreAppReleaseService ', error);
    }
}
 
export const markAsReadAppReleaseService = async (data: { idNew: string }) => {
    try {
        return await http.post<any>(`/v1/app-releases/mark-read`, data);
    } catch (error: any) {
        if (error && !error.ok) return error;
        console.log('markAsReadAppReleaseService ', error);
    }
}
